<template>
    
    <div class="setting-item" @click="$emit('click')">
      <!-- <CIcon :name="icon" size="xl" class="setting-icon" /> -->
      <img v-if="image" :src="require(`@/assets/${image}`)" alt="icon" class="setting-icon" />
    <i v-else :class="icon"></i>
      <span class="setting-label">{{ label }}</span>
      <img src="../assets/img/new/arrow-right.png" class="chevron-icon" width="16px"/>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      icon: String,
      label: String,
      image: String,
    },
    methods: {
  
  },
  };
  </script>
  
  <style scoped>
  .setting-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    font-size: 14px;
    cursor: pointer;
  }
  
  .setting-icon {
    margin-right: 10px;
    color: #666;
    width:20px;
  }
  
  .setting-label {
    flex: 1;
    text-align: left;
    color:#111927;
  }
  
  .chevron-icon {
    color: #666;
  }
  </style>